import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Faturas',
  form: {
    title: 'Solicitar novo pagamento',
    company: {
      label: 'Restaurante',
    },
    billing_mode: {
      label: 'Fonte de faturação',
    },
    billing_anchor: {
      label: 'Iniciar faturação em',
    },
    items: {
      label: 'Itens',
    },
    name: {
      label: 'Nome',
      placeholder: '1000x Flyers',
    },
    net_amount: {
      label: 'Valor (Líquido)',
      tax_breakdown: '+{{tax}} IVA = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurante',
    name: 'Nome/Número',
    billing_mode: 'Fonte de faturação',
    type: 'Tipo',
    status: 'Estado',
    amount: 'Valor (Bruto)',
    created_at: 'Criado',
    billing_anchor: 'Faturação desde',
    invoice: 'Fatura',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Método de pagamento',
    [BillingMode.InternalInvoicing]: 'Vendas',
  },
  types: {
    [InvoiceType.Manual]: 'Manual',
    [InvoiceType.SetupFee]: 'Taxa de configuração',
    [InvoiceType.Subscription]: 'Subscrição',
    [InvoiceType.SubscriptionBridge]: 'Subscrição (proporcional até ao dia 5)',
    [InvoiceType.SubscriptionProration]: 'Subscrição (upgrade proporcional)',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'Pendente',
    [InvoiceStatus.Processing]: 'Em processamento',
    [InvoiceStatus.Paid]: 'Pago',
    [InvoiceStatus.PartiallyRefunded]: 'Parcialmente reembolsado',
    [InvoiceStatus.Refunded]: 'Reembolsado',
    [InvoiceStatus.Failed]: 'Falhado',
  },
  modals: {
    invoice_creation_confirmation: {
      title:
        'Tem a certeza de que pretende criar uma fatura de {{amount}} Líquido para {{company}} via {{billingMode}}?',
    },
    invoice_recharge_confirmation: {
      title: 'Tem a certeza?',
      description:
        '<strong>{{company}}</strong> será cobrado <strong>{{amount}} bruto + penalidade por falha de pagamento, se aplicável</strong> através do método de pagamento principal para a fatura {{details}}',
      recharge_failed: {
        title: 'O Stripe recusou o pagamento',
        convert_hint:
          'Pode cobrar esta fatura a partir das vendas do restaurante. A fatura Stripe será anulada e o valor em dívida será deduzido dos próximos pagamentos.',
      },
    },
  },
  buttons: {
    show_transfers: 'Mostrar transferências',
    hide_transfers: 'Ocultar transferências',
    create: 'Criar',
    download_pdf: 'Transferir PDF',
    open_payment_page: 'Abrir página de pagamento',
    open_invoice_page: 'Abrir detalhes da fatura',
    add_item: 'Adicionar item',
    convert_to_internal_billing: 'Cobrar pelas vendas',
    recharge_invoice: 'Reprocessar fatura',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_create_invoice: 'Falha ao criar fatura!',
    invoice_got_created: 'Fatura criada!',
    invoice_got_recharged: 'Fatura reprocessada. O novo pagamento está a ser processado!',
    failed_to_recharge_invoice: 'Falha ao reprocessar a fatura!',
    invoice_got_converted_to_internal_billing:
      'Fatura convertida para faturação por vendas. O valor em dívida será deduzido dos próximos pagamentos.',
    failed_to_convert_invoice_to_internal_billing: 'Falha ao converter a fatura para faturação por vendas!',
  },
};
